// Bloco 3 — Validações e máscaras (Sprint Estabilidade)
// Funções puras: máscaras + validações algorítmicas

// ============ CPF ============
export const maskCPF = (v) => {
  const d = String(v || "").replace(/\D/g, "").slice(0, 11);
  return d
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
};

export const validaCPF = (cpf) => {
  const d = String(cpf || "").replace(/\D/g, "");
  if (d.length !== 11) return false;
  // Rejeita todos iguais
  if (/^(\d)\1+$/.test(d)) return false;
  const calc = (base, peso) => {
    let s = 0;
    for (let i = 0; i < base.length; i++) s += parseInt(base[i], 10) * (peso - i);
    const r = (s * 10) % 11;
    return r === 10 ? 0 : r;
  };
  const dv1 = calc(d.substring(0, 9), 10);
  if (dv1 !== parseInt(d[9], 10)) return false;
  const dv2 = calc(d.substring(0, 10), 11);
  return dv2 === parseInt(d[10], 10);
};

// ============ CNPJ ============
export const maskCNPJ = (v) => {
  const d = String(v || "").replace(/\D/g, "").slice(0, 14);
  return d
    .replace(/(\d{2})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1/$2")
    .replace(/(\d{4})(\d{1,2})$/, "$1-$2");
};

export const validaCNPJ = (cnpj) => {
  const d = String(cnpj || "").replace(/\D/g, "");
  if (d.length !== 14) return false;
  if (/^(\d)\1+$/.test(d)) return false;
  const calc = (base) => {
    const pesos = base.length === 12
      ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
      : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    let s = 0;
    for (let i = 0; i < base.length; i++) s += parseInt(base[i], 10) * pesos[i];
    const r = s % 11;
    return r < 2 ? 0 : 11 - r;
  };
  const dv1 = calc(d.substring(0, 12));
  if (dv1 !== parseInt(d[12], 10)) return false;
  const dv2 = calc(d.substring(0, 13));
  return dv2 === parseInt(d[13], 10);
};

// ============ Telefone ============
export const maskTelefone = (v) => {
  const d = String(v || "").replace(/\D/g, "").slice(0, 11);
  if (d.length <= 10) {
    // Fixo: (XX) XXXX-XXXX
    return d
      .replace(/(\d{2})(\d)/, "($1) $2")
      .replace(/(\d{4})(\d{1,4})$/, "$1-$2");
  }
  // Celular: (XX) XXXXX-XXXX
  return d
    .replace(/(\d{2})(\d)/, "($1) $2")
    .replace(/(\d{5})(\d{1,4})$/, "$1-$2");
};

export const validaTelefone = (tel) => {
  const d = String(tel || "").replace(/\D/g, "");
  if (d.length !== 10 && d.length !== 11) return false;
  const ddd = parseInt(d.substring(0, 2), 10);
  if (ddd < 11 || ddd > 99) return false;
  // Celular precisa começar com 9 no terceiro dígito
  if (d.length === 11 && d[2] !== "9") return false;
  return true;
};

// ============ Datas ============
export const maskData = (v) => {
  const d = String(v || "").replace(/\D/g, "").slice(0, 8);
  return d
    .replace(/(\d{2})(\d)/, "$1/$2")
    .replace(/(\d{2})(\d{1,4})$/, "$1/$2");
};

export const validaData = (str) => {
  // Aceita DD/MM/AAAA ou YYYY-MM-DD
  if (!str) return false;
  let dia, mes, ano;
  if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
    [ano, mes, dia] = str.split("-").map(Number);
  } else if (/^\d{2}\/\d{2}\/\d{4}$/.test(str)) {
    [dia, mes, ano] = str.split("/").map(Number);
  } else {
    return false;
  }
  if (mes < 1 || mes > 12) return false;
  if (dia < 1 || dia > 31) return false;
  const dt = new Date(ano, mes - 1, dia);
  return dt.getFullYear() === ano && dt.getMonth() === mes - 1 && dt.getDate() === dia;
};

export const dataNoFuturo = (str) => {
  if (!validaData(str)) return false;
  let dt;
  if (/^\d{4}-\d{2}-\d{2}$/.test(str)) dt = new Date(str + "T00:00:00");
  else {
    const [dia, mes, ano] = str.split("/").map(Number);
    dt = new Date(ano, mes - 1, dia);
  }
  return dt.getTime() > new Date().setHours(23, 59, 59, 999);
};

export const dataPosterior = (data, dataReferencia) => {
  if (!validaData(data) || !validaData(dataReferencia)) return false;
  const toMs = (s) => {
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return new Date(s + "T00:00:00").getTime();
    const [d, m, a] = s.split("/").map(Number);
    return new Date(a, m - 1, d).getTime();
  };
  return toMs(data) > toMs(dataReferencia);
};
